import type {GetProducts_products_edges_node as Product} from 'nutshell-graphql-types';

export const BASE_COLUMNS = [
    {
        column: {
            id: 'sku',
            Header: 'SKU',
            accessor: (row: Product) => row.sku,
            dataType: 'string',
            width: 85,
            canResize: true,
        },
        index: 2,
    },
] as const;
